import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, path = "/", jsonLd }) => (
  <Helmet>
    <title>{title}</title>
    {description && <meta name="description" content={description} />}
    <meta property="og:title" content={title} />
    {description && <meta property="og:description" content={description} />}
    <meta name="twitter:title" content={title} />
    {description && <meta name="twitter:description" content={description} />}
    {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
  </Helmet>
);
